import React from "react";
import {CommonService} from "../../service/commons/CommonService";
import GuaranteeData from "./GuaranteeDataView";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {amount, rateMultipliedByOneHundred} from "../../utils/formatters/Numbers";


export default class GuaranteeDataContainer extends React.Component {
    constructor(props) {
        super(props);

        this.commonService = new CommonService();
        this.getGuarantee = this.getGuarantee.bind(this);
        this.calculateTotals = this.calculateTotals.bind(this);

        this.state = {
            loanId: props.loanId,
            loanStatusPV: props.loanStatusPV === undefined ? "" : props.loanStatusPV,
            guaranteeList: [],
            amount: 0,
            guaranteedPercent: 0,
        };

        this.getGuarantee();
    }

    calculateTotals(response) {
        let amount = 0;
        let guaranteedPercent = 0;

        response.map((item) => {
            amount += item.importe;
            guaranteedPercent += item.porcentajeGarantizado;
            return '';
        });

        this.setState({
            amount: amount,
            guaranteedPercent: guaranteedPercent,
        })
    }

    getGuarantee() {
        this.commonService.getGuarantee(this.state.loanId)
            .then(response => {
                this.setState({
                    guaranteeList: response[0],
                });
                this.calculateTotals(response[0]);
                this.props.loading(false);
            });
    }

    render() {
        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="Totales:" colSpan={4} style={{textAlign: 'right'}}/>
                    <Column footer={amount(this.state.amount, 'right')}/>
                    <Column footer=""/>
                    <Column footer={rateMultipliedByOneHundred(this.state.guaranteedPercent, 'right')}/>
                    <Column footer=""/>
                </Row>
            </ColumnGroup>;


        return <GuaranteeData
            guaranteeList={this.state.guaranteeList}
            loanStatusPV={this.state.loanStatusPV}
            footerColumnGroup={footerColumnGroup}
        />
    }
};